/* eslint react/prop-types: 0 */
import React, { useContext } from "react";
import { Link } from "gatsby";

import SiteMetaContext from "../../../contexts/SiteMetaContext";
import { formatPrice } from "../../../helpers/propertyHelper";
import { getTranslatedValue } from "../../../helpers/translationHelper";
import { prepareImageURL } from "../../../helpers/helper";
import * as theme4Styles from "../scss/theme4.module.scss";

import property1 from "../images/property-image-1.jpg";

// eslint-disable-next-line react/prop-types
const PropertyList = ({ properties, locale, defaultLocale }) => {
  const siteData = useContext(SiteMetaContext);
  const {
    remarso: {
      domainByURL: {
        website: {
          company: { currency: company_currency },
        },
      },
    },
  } = siteData;

  return (
    <div className={`${theme4Styles.productRow}`}>
      {properties.map((property) => {
        const {
          pictures,
          property_type,
          category,
          measurement_unit,
          translations,
        } = property;

        let picture =
          pictures.length > 0
            ? prepareImageURL(pictures[0], 480, 320, false)
            : property1;

        return (
          <div className={theme4Styles.colm} key={property.uuid}>
            <div className={`${theme4Styles.productBox}`}>
              <Link
                to={`/${locale}/property/${property.uuid}`}
                className={theme4Styles.image}
              >
                <img src={picture} alt="" />
                <span className={theme4Styles.uuid}>{property.reference}</span>
                <span className={theme4Styles.category}>
                  {(() => {
                    const propertyType = property_type
                      ? getTranslatedValue(
                          property_type.translations,
                          "name",
                          locale,
                          defaultLocale
                        )
                      : null;
                    const propertyCategory = category
                      ? getTranslatedValue(
                          category.translations,
                          "name",
                          locale,
                          defaultLocale
                        )
                      : null;

                    if (propertyType && !propertyCategory) {
                      return propertyType;
                    }
                    if (!propertyType && propertyCategory) {
                      return propertyCategory;
                    }
                    if (propertyType && propertyCategory) {
                      return `${propertyType} for ${propertyCategory}`;
                    }
                  })()}
                </span>
                <div className={`${theme4Styles.infoC}`}>
                  <div className={`${theme4Styles.leftC}`}>
                    <span className={theme4Styles.price}>
                      {formatPrice(property, company_currency)}
                    </span>
                    <h4
                      dangerouslySetInnerHTML={{
                        __html:
                          getTranslatedValue(
                            translations,
                            "headline",
                            locale,
                            defaultLocale
                          ) || "",
                      }}
                    ></h4>
                    <h4>{property.location}</h4>
                  </div>
                  <ul className={theme4Styles.features}>
                    <li>
                      {property.bedrooms}
                      <abbr> Beds</abbr>
                    </li>
                    <li>
                      {property.bathrooms}
                      <abbr> Baths</abbr>
                    </li>
                    <li>
                      {property.internal_area_value}
                      <abbr>
                        {" "}
                        {measurement_unit ? measurement_unit.name : ""}
                      </abbr>
                    </li>
                  </ul>
                </div>
              </Link>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default PropertyList;
